module.exports = __webpack_public_path__ + "static/media/img2.5a618fd2.jpeg";